import { render } from "./ConsultRegionInfoView.vue?vue&type=template&id=c1a4c854&scoped=true"
import script from "./ConsultRegionInfoView.vue?vue&type=script&lang=js"
export * from "./ConsultRegionInfoView.vue?vue&type=script&lang=js"

import "./ConsultRegionInfoView.vue?vue&type=style&index=0&id=c1a4c854&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a4c854"]])

export default __exports__